var classof   = require('./_classof')
  , ITERATOR  = require('./_wks')('iterator')
  , Iterators = require('./_iterators');
module.exports = require('./_core').isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/core.is-iterable.js
// module id = 570
// module chunks = 1